import { MobileDrawer } from '@components/MobileDrawer/MobileDrawer';
import { Switch } from '@components/Switch/Switch';
import { ActionButton } from '@pages/ActionButton';
import css from './MobileFilterDrawer.module.scss';

type MobileFilterDrawerProps = {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  placeholder: string;
  value: string | null;
  /** Live-applied on each keystroke (same behavior the popover had). */
  onChange: (value: string | null) => void;
  /** Explicit confirm (Apply button / Enter) — closes via the caller. */
  onApply: () => void;
  onClear: () => void;
  matchAll: boolean;
  onMatchAllChange: (matchAll: boolean) => void;
};

/**
 * The mobile omnifilter editor as a bottom drawer — shared by the libraries page
 * (name filter) and the per-library page (title filter), matching the other
 * pick-from-drawer flows (sort, view mode, autoplay).
 */
export const MobileFilterDrawer = ({
  open,
  onClose,
  onOpen,
  placeholder,
  value,
  onChange,
  onApply,
  onClear,
  matchAll,
  onMatchAllChange,
}: MobileFilterDrawerProps) => {
  return (
    <MobileDrawer open={open} onClose={onClose} onOpen={onOpen} frosted>
      <div className={css.content}>
        <span className={css.title}>Filter by anything</span>
        <input
          className={css.input}
          placeholder={placeholder}
          autoComplete="off"
          autoFocus
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value.length > 0 ? e.target.value : null)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onApply();
            }
          }}
        />
        <div className={css.actions}>
          <ActionButton variant="secondary" onClick={onClear}>
            Clear
          </ActionButton>
          <ActionButton onClick={onApply}>Apply</ActionButton>
        </div>
        <div className={css.matchModeRow}>
          <span className={css.matchModeLabel} onClick={() => onMatchAllChange(!matchAll)}>
            Match all terms
          </span>
          <Switch checked={matchAll} onChange={onMatchAllChange} />
        </div>
      </div>
    </MobileDrawer>
  );
};
